import React, { useState } from 'react';
import {
  Typography, IconButton,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Box, Container, Stack, Dialog, DialogActions, DialogContent, DialogTitle, TextField,
  Chip, Avatar
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import Footer from '../Materials/Footer';
import CommentIcon from '@mui/icons-material/Comment';
import BurgerBar from '../Materials/BurgerBar';

export default function SpeedMeetingStatusPage() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [speedMeetings, setSpeedMeetings] = useState([
    { 
      id: 1, 
      name: 'Reunião com Cliente A', 
      description: 'Discussão sobre parceria', 
      entity: 'Empresa X', 
      created_by: 1, 
      status: 'scheduled', // scheduled, pending, completed, cancelled
      comments: '' 
    },
    { 
      id: 2, 
      name: 'Reunião com Fornecedor B', 
      description: 'Negociação de preços', 
      entity: 'Empresa Y', 
      created_by: 2, 
      status: 'pending', 
      comments: 'Aguardando confirmação' 
    },
    { 
      id: 3, 
      name: 'Reunião Interna', 
      description: 'Planejamento trimestral', 
      entity: 'Empresa Z', 
      created_by: 3, 
      status: 'completed', 
      comments: 'Todas ações definidas' 
    },
    { 
      id: 4, 
      name: 'Reunião Cancelada', 
      description: 'Demonstração de produto', 
      entity: 'Empresa W', 
      created_by: 1, 
      status: 'cancelled', 
      comments: 'Cliente desistiu' 
    },
  ]);
  
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [currentMeeting, setCurrentMeeting] = useState(null);
  const [commentText, setCommentText] = useState('');
  const [users] = useState([
    { id: 1, name: 'John Doe' },
    { id: 2, name: 'Jane Smith' },
    { id: 3, name: 'Alice Johnson' },
  ]);
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExit = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setOpenDrawer(false);
  };

  const getUserNameById = (userId) => {
    const user = users.find(user => user.id === userId);
    return user ? user.name : 'Unknown User';
  };

  // Funções para manipular o estado da reunião
  const handleOpenCommentDialog = (meeting) => {
    setCurrentMeeting(meeting);
    setCommentText(meeting.comments || '');
    setOpenCommentDialog(true);
  };

  const handleCloseCommentDialog = () => {
    setOpenCommentDialog(false);
    setCurrentMeeting(null);
    setCommentText('');
  };

  const handleSaveComment = () => {
    if (currentMeeting) {
      const updatedMeetings = speedMeetings.map(meeting => 
        meeting.id === currentMeeting.id 
          ? { ...meeting, comments: commentText } 
          : meeting
      );
      setSpeedMeetings(updatedMeetings);
    }
    handleCloseCommentDialog();
  };

  const handleOpenCancelDialog = (meeting) => {
    setCurrentMeeting(meeting);
    setOpenCancelDialog(true);
  };

  const handleCloseCancelDialog = () => {
    setOpenCancelDialog(false);
    setCurrentMeeting(null);
  };

  const handleCancelMeeting = () => {
    if (currentMeeting) {
      const updatedMeetings = speedMeetings.map(meeting => 
        meeting.id === currentMeeting.id 
          ? { ...meeting, status: 'cancelled' } 
          : meeting
      );
      setSpeedMeetings(updatedMeetings);
    }
    handleCloseCancelDialog();
  };

  // Função para obter a cor e ícone com base no status
  const getStatusProps = (status) => {
    switch (status) {
      case 'scheduled':
        return { color: 'default', icon: <ScheduleIcon />, label: 'Agendada' };
      case 'pending':
        return { color: 'warning', icon: <EditIcon />, label: 'Agendada não realizada' };
      case 'completed':
        return { color: 'success', icon: <DoneAllIcon />, label: 'Agendada e realizada' };
      case 'cancelled':
        return { color: 'secondary', icon: <CancelIcon />, label: 'Cancelada' };
      default:
        return { color: 'default', icon: null, label: 'Desconhecido' };
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <BurgerBar />

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Paper sx={{ p: 3 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Entity</TableCell>
                  <TableCell>Speedmeeting By</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {speedMeetings.map((meeting) => {
                  const statusProps = getStatusProps(meeting.status);
                  return (
                    <TableRow key={meeting.id}>
                      <TableCell>{meeting.name}</TableCell>
                      <TableCell>{meeting.description}</TableCell>
                      <TableCell>{meeting.entity}</TableCell>
                      <TableCell>{getUserNameById(meeting.created_by)}</TableCell>
                      <TableCell align="center">
                        <Chip
                          avatar={<Avatar>{statusProps.icon}</Avatar>}
                          label={statusProps.label}
                          color={statusProps.color}
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Stack direction="row" spacing={1} justifyContent="center">
                          <IconButton 
                            color="primary" 
                            onClick={() => handleOpenCommentDialog(meeting)}
                          >
                            <CommentIcon />
                          </IconButton>
                          {meeting.status !== 'cancelled' && meeting.status !== 'completed' && (
                            <IconButton 
                              color="error" 
                              onClick={() => handleOpenCancelDialog(meeting)}
                            >
                              <CancelIcon />
                            </IconButton>
                          )}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Container>

      {/* Dialog para adicionar/comentar */}
      <Dialog
        open={openCommentDialog}
        onClose={handleCloseCommentDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Adicionar Comentário</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Comentário"
            type="text"
            fullWidth
            variant="outlined"
            multiline
            rows={4}
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCommentDialog}>Cancelar</Button>
          <Button onClick={handleSaveComment} color="primary">Salvar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog para cancelar */}
      <Dialog
        open={openCancelDialog}
        onClose={handleCloseCancelDialog}
      >
        <DialogTitle>Confirmar Cancelamento</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Tem certeza que deseja cancelar a speedmeeting "{currentMeeting?.name}"?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCancelDialog}>Não</Button>
          <Button onClick={handleCancelMeeting} color="error">Sim, Cancelar</Button>
        </DialogActions>
      </Dialog>

      <Box>
        <Footer />
      </Box>           
    </Box>
  );
}